import { Button, Col, Tooltip } from "antd";
import React, { useRef, useState, useEffect } from "react";
import "./Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import RecommentAndPolicy from "../../Components/RecommendArtistAndPolicy/RecommentAndPolicy";
import { useNavigate } from "react-router-dom";

function Home() {
  const imageUrls = [
    {
      name: "Back to the Basics - Lana Del Rey",
      imgUrl:
        "https://scontent.fhan5-8.fna.fbcdn.net/v/t1.15752-9/486405619_533666639754428_4878220466342871859_n.png?_nc_cat=106&ccb=1-7&_nc_sid=9f807c&_nc_ohc=9qqy5-iPZiIQ7kNvgFry3cm&_nc_oc=AdkrbwTUg2QCZt1PDPFfGk0TUxUCbgzaqc5Nc9VSY5pfXMpA4m9GQJyhE7cmAzfSIFA&_nc_zt=23&_nc_ht=scontent.fhan5-8.fna&oh=03_Q7cD1wF2OEB6-k1-wT0pexcORsY2kkvxpqdpjKinMDagHoSpeA&oe=680CE42E",
    },
    {
      name: "Recovery - Eminem",
      imgUrl:
        "https://upload.wikimedia.org/wikipedia/en/6/60/Recovery_Album_Cover.jpg",
    },
    {
      name: "Been Through demo - Lana Del Rey",
      imgUrl:
        "https://scontent.fhan5-11.fna.fbcdn.net/v/t1.15752-9/485275261_1625650021409523_5413146881214408810_n.png?_nc_cat=100&ccb=1-7&_nc_sid=9f807c&_nc_ohc=loL6MplEWKkQ7kNvgHeU97g&_nc_oc=AdkTvjE1XuCcLmv6mmSVknzNcDUqpnwez-8KxhfgLoWE2tGwNY7FWbH1sSynyVBG0bo&_nc_zt=23&_nc_ht=scontent.fhan5-11.fna&oh=03_Q7cD1wHbltZLvLwl17Pudo71xIQNWioGk_Wu5dzlDmHYedlwjw&oe=680CDAFB",
    },
    {
      name: "Đánh đổi - Obito",
      imgUrl:
        "https://i.scdn.co/image/ab67616d0000b273a06a6b51d0dc296d48505ee6",
    },
    {
      name: "Behind closed doors - Lana Del Rey",
      imgUrl:
        "https://scontent.fhan5-8.fna.fbcdn.net/v/t1.15752-9/416089062_1085177822717961_7194232295654635691_n.png?_nc_cat=108&ccb=1-7&_nc_sid=9f807c&_nc_ohc=iWzRxTa2mKcQ7kNvgH_ZLQX&_nc_oc=AdmmLf-tFNi5GsEQWP2OT77HNah9dCnXI_-mpX8rwXEqg0WpDpnrrDqceBO3Y3yCEUI&_nc_zt=23&_nc_ht=scontent.fhan5-8.fna&oh=03_Q7cD1wFk0TCAycCrDRG5AiYZp0pMW3skt6KkO2nYr36r1ucPfg&oe=680CDED2",
    },
    {
      name: "Loi Choi - Wren Evans",
      imgUrl: "https://i.ytimg.com/vi/A8C71-mSkAk/maxresdefault.jpg",
    },
    {
      name: "Chiều hôm ấy anh thấy màu đỏ - Wren Evans",
      imgUrl:
        "https://i.scdn.co/image/ab67616d0000b2732882b6e41f84457fcc744ef3",
    },
    {
      name: "Gabriel - Keshi",
      imgUrl:
        "https://product.hstatic.net/1000304920/product/keshi-gabriel-phien-ban-co-chu-ky-dia-cd_e615a6fe309c4970bacc071613265a33.jpeg",
    },
    {
      name: "Devine - Ed Sheeran",
      imgUrl:
        "https://upload.wikimedia.org/wikipedia/vi/thumb/4/45/Divide_cover.png/220px-Divide_cover.png",
    },
    {
      name: "99% - MCK",
      imgUrl: "https://i.ytimg.com/vi/5WkwBKu1le0/mqdefault.jpg",
    },
    {
      name: "Doo-Wops & Hooligans - Bruno Mars",
      imgUrl:
        "https://upload.wikimedia.org/wikipedia/vi/f/fd/Bruno_Mars_-_Doo-Wops_%26_Hooligans.jpg",
    },
  ];

  return (
    <>
      <Col span={12} offset={3}>
        <ImageCarousel images={imageUrls} title="trending" />
      </Col>
      <Col span={5} offset={1}>
        <RecommentAndPolicy type={"inHomepage"} />
      </Col>
    </>
  );
}

const ImageCarousel = ({ images, title }) => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const titleRefs = useRef([]); // Mảng refs cho các span
  const [showTooltips, setShowTooltips] = useState([]);

  useEffect(() => {
    const tooltipStates = images.map((_, index) => {
      // thay tracks thành images
      const spanElement = titleRefs.current[index];
      return spanElement && spanElement.scrollWidth > 150;
    });
    setShowTooltips(tooltipStates);
  }, [images]);

  const navigateMetadata = (index, audioLinks) => {
    navigate(`/playlists/${index}`, {
      state: {
        audioLinks: audioLinks,
      },
    });
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -600,
        behavior: "smooth",
      });
    }
  };
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 600,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div className="carouselWrapperHeader">
        <span className="carouselHeader">{title}</span>
      </div>
      <div className="carouselWrapper">
        <button className="scrollButton left" onClick={scrollLeft}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <div className="imageContainer" ref={scrollContainerRef}>
          {images?.map((img, index) => {
            const audioLinks = [
              { audioId: "audio_1", link: "/test1.mp3" },
              { audioId: "audio_2", link: "/test2.mp3" },
              { audioId: "audio_3", link: "/test2.mp3" },
              { audioId: "audio_4", link: "/test4.mp3" },
              { audioId: "audio_5", link: "/test1.mp3" },
              { audioId: "audio_6", link: "/test3.mp3" },
              { audioId: "audio_7", link: "/test4.mp3" },
              { audioId: "audio_8", link: "/test2.mp3" },
              { audioId: "audio_9", link: "/test3.mp3" },
            ];
            return (
              <div className="imageWrapper" key={index}>
                <img
                  src={img?.imgUrl}
                  alt={`Image ${index}`}
                  className="carouselImage"
                  onClick={() => navigateMetadata(index, audioLinks)}
                />
                {showTooltips[index] ? (
                  <Tooltip
                    placement="top"
                    overlayInnerStyle={{
                      width: "180px",
                    }}
                    title={img.name}
                  >
                    <span
                      ref={(el) => (titleRefs.current[index] = el)}
                      className="homeAlbumName"
                    >
                      {img?.name}
                    </span>
                  </Tooltip>
                ) : (
                  <span
                    ref={(el) => (titleRefs.current[index] = el)}
                    className="homeAlbumName"
                  >
                    {img?.name}
                  </span>
                )}

                <span className="homeAlbumCategory">indie</span>
              </div>
            );
          })}
        </div>
        <button className="scrollButton right" onClick={scrollRight}>
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
    </>
  );
};

export default Home;
